.container {
	display: flex;
	align-items: start;
	margin-bottom: 4px;
	margin-top: 2px;
}

.color {
	display: flex;
	height: 16px;
	width: 16px;
	min-width: 16px;
	min-height: 16px;
	border-radius: 1px;
	margin-right: 5px;
	margin-top: 2px;
}
